import CarRow from './CarRow';

export default CarRow;



// WEBPACK FOOTER //
// ./src/components/CarRow/index.js